var _title, _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBreezeMark = function SvgBreezeMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "38px",
    viewBox: "0 0 40 38",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "breeze_logo_icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.977196%",
    y1: "11.7419814%",
    x2: "47.7082905%",
    y2: "51.7759046%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F869D5",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A472FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "104.896687%",
    y1: "17.1847837%",
    x2: "33.8317925%",
    y2: "68.4554537%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7676",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F966BE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "115.285663%",
    y1: "-6.86167454%",
    x2: "36.7417678%",
    y2: "53.3683904%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4AFFB1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BD2FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HS-home-page-refresh-2020_test",
    transform: "translate(-77.000000, -6540.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "breeze_logo_icon",
    transform: "translate(77.000000, 6540.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-1)",
    points: "0.0609970674 29.8590816 17.1659824 12.8963469 22.7628543 18.4466735 36.7151515 4.61040816 39.9941349 7.86212245 22.8183773 24.8954286 17.1605083 19.285 3.27937439 33.0506939"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5096774,0.589 L0,15.749449 L3.49755621,19.2683265 L16.9341153,6.14242857 L22.5481916,11.7904694 L26.0954057,8.32393878 L18.4281525,0.609938776 C17.6280669,-0.195052096 16.3214241,-0.204426684 15.5096774,0.589 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,22.0403878 L36.459433,18.5292653 L23.0521994,31.8168571 L17.3685239,26.1812245 L13.82913,29.6904082 L21.5882698,37.3850204 C21.9769822,37.7709808 22.5044803,37.9878515 23.0545455,37.9878515 C23.6046106,37.9878515 24.1321087,37.7709808 24.5208211,37.3850204 L40,22.0403878 Z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBreezeMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/breeze-mark.d8b94e9e.svg";
export { ForwardRef as ReactComponent };